if (!customElements.get('pack-builder')) {
  class PackBuilder extends HTMLElement {
    constructor() {
      super();
      this.lines = [];
      this.i18n = {};
      this.activeProduct = null;
      this.editingUid = null;
      this.selectedPatch = '';
this.selectedExtraPatch = '';
this.selectedMedias = false;
this.selectedVariantId = '';
this.selectedVariantTitle = '';
this.isSubmitting = false;
    }

    getI18n() {
      const node = this.querySelector('[data-pack-i18n]');
      if (!node) return {};
      try {
        return JSON.parse(node.textContent || '{}');
      } catch (error) {
        return {};
      }
    }

    t(key, fallback) {
      return this.i18n[key] || fallback;
    }

    format(key, fallback, values = {}) {
      return String(this.t(key, fallback)).replace(/{{\s*(\w+)\s*}}/g, (match, name) => {
        return Object.prototype.hasOwnProperty.call(values, name) ? values[name] : match;
      });
    }

    connectedCallback() {
      this.i18n = this.getI18n();
      this.minRequired = parseInt(this.dataset.packMinRequired || '3', 10);
      this.packTitle = this.dataset.packTitle || this.t('default_pack_title', 'Pack');
      this.packSource = this.dataset.packSource || '';
      this.emptyText = this.dataset.emptyText || this.t('emptyText', 'Todavia no has anadido productos al pack.');
      this.emptySubtext = this.dataset.emptySubtext || this.t('emptySubtext', 'Elige abajo los articulos que quieras incluir.');

      this.linesContainer = this.querySelector('[data-pack-lines]');
      this.progressText = this.querySelector('[data-pack-progress]');
      this.submitButton = this.querySelector('[data-pack-submit]');

      this.modal = this.querySelector('[data-pack-modal]');
      this.modalTitle = this.querySelector('[data-pack-modal-title]');
      this.modalSubtitle = this.querySelector('[data-pack-modal-subtitle]');
      this.modalNotice = this.querySelector('[data-pack-modal-notice]');
      this.modalError = this.querySelector('[data-pack-modal-error]');

      this.fieldWraps = {
  variant: this.querySelector('[data-pack-field-wrap="variant"]'),
  playerPreset: this.querySelector('[data-pack-field-wrap="player-preset"]'),
  name: this.querySelector('[data-pack-field-wrap="name"]'),
  number: this.querySelector('[data-pack-field-wrap="number"]'),
  patch: this.querySelector('[data-pack-field-wrap="patch"]'),
  extraPatch: this.querySelector('[data-pack-field-wrap="extra-patch"]'),
  medias: this.querySelector('[data-pack-field-wrap="medias"]')
};

      this.variantGrid = this.querySelector('[data-pack-variant-grid]');
      this.playerPresetSelect = this.querySelector('[data-pack-player-preset-select]');

      this.toggles = {
  name: this.querySelector('[data-pack-toggle="name"]'),
  number: this.querySelector('[data-pack-toggle="number"]'),
  patch: this.querySelector('[data-pack-toggle="patch"]'),
  extraPatch: this.querySelector('[data-pack-toggle="extra-patch"]'),
  medias: this.querySelector('[data-pack-toggle="medias"]')
};

      this.panels = {
  name: this.querySelector('[data-pack-panel="name"]'),
  number: this.querySelector('[data-pack-panel="number"]'),
  patch: this.querySelector('[data-pack-panel="patch"]'),
  extraPatch: this.querySelector('[data-pack-panel="extra-patch"]'),
  medias: this.querySelector('[data-pack-panel="medias"]')
};

      this.inputs = {
        name: this.querySelector('[data-pack-input="name"]'),
        number: this.querySelector('[data-pack-input="number"]')
      };

      this.patchContainers = {
        patch: this.querySelector('[data-pack-patches="patch"]'),
        extraPatch: this.querySelector('[data-pack-patches="extra-patch"]')
      };

      this.fieldErrors = {
        variant: this.querySelector('[data-pack-field-error="variant"]'),
        name: this.querySelector('[data-pack-field-error="name"]'),
        number: this.querySelector('[data-pack-field-error="number"]'),
        patch: this.querySelector('[data-pack-field-error="patch"]'),
        extraPatch: this.querySelector('[data-pack-field-error="extra-patch"]')
      };

      this.saveButton = this.querySelector('[data-pack-save]');

      this.bindEvents();
      this.renderLines();
    }

    bindEvents() {
      this.querySelectorAll('[data-pack-add-product]').forEach((button) => {
        button.addEventListener('click', () => {
          const product = JSON.parse(button.getAttribute('data-product'));
          this.openModal(product);
        });
      });

      this.querySelectorAll('[data-pack-modal-close]').forEach((button) => {
        button.addEventListener('click', () => this.closeModal());
      });

      this.toggles.name?.addEventListener('change', () => this.syncPanel('name'));
      this.toggles.number?.addEventListener('change', () => this.syncPanel('number'));
      this.toggles.patch?.addEventListener('change', () => this.syncPanel('patch'));
      this.toggles.extraPatch?.addEventListener('change', () => this.syncPanel('extraPatch'));
      this.toggles.medias?.addEventListener('change', () => this.syncPanel('medias'));

      if (this.playerPresetSelect) {
        this.playerPresetSelect.addEventListener('change', () => this.applyPlayerPreset());
      }

      if (this.inputs.name) {
        this.inputs.name.addEventListener('input', () => {
          this.inputs.name.value = this.normalizeNameValue(this.inputs.name.value);
          this.clearFieldError('name');
          this.clearModalError();
        });
      }

      if (this.inputs.number) {
        this.inputs.number.addEventListener('input', () => {
          this.inputs.number.value = this.normalizeNumberValue(this.inputs.number.value);
          this.clearFieldError('number');
          this.clearModalError();
        });
      }

      this.saveButton?.addEventListener('click', () => this.saveLine());
      this.submitButton?.addEventListener('click', () => this.submitPack());

      this.linesContainer?.addEventListener('click', (event) => {
        const editButton = event.target.closest('[data-pack-edit]');
        const removeButton = event.target.closest('[data-pack-remove]');

        if (editButton) {
          const uid = editButton.getAttribute('data-pack-edit');
          const line = this.lines.find((item) => item.uid === uid);
          if (!line) return;
          this.openModal(line.product, line);
        }

        if (removeButton) {
          const uid = removeButton.getAttribute('data-pack-remove');
          this.lines = this.lines.filter((item) => item.uid !== uid);
          this.renderLines();
        }
      });
    }

    syncPanel(field) {
      const toggle = this.toggles[field];
      const panel = this.panels[field];
      if (!toggle || !panel) return;

      panel.hidden = !toggle.checked;

      if (!toggle.checked) {
  if (field === 'name' && this.inputs.name) this.inputs.name.value = '';
  if (field === 'number' && this.inputs.number) this.inputs.number.value = '';
  if (field === 'patch') this.selectedPatch = '';
  if (field === 'extraPatch') this.selectedExtraPatch = '';
  if (field === 'medias') this.selectedMedias = false;

  if (field === 'patch' && this.patchContainers.patch) {
    this.patchContainers.patch.querySelectorAll('.pack-modal__patch').forEach((node) => {
      node.classList.remove('is-selected');
    });
  }

  if (field === 'extraPatch' && this.patchContainers.extraPatch) {
    this.patchContainers.extraPatch.querySelectorAll('.pack-modal__patch').forEach((node) => {
      node.classList.remove('is-selected');
    });
  }
} else if (field === 'medias') {
  this.selectedMedias = true;
}

      this.clearFieldError(field);
      this.clearModalError();
    }

    resetModal() {
      this.editingUid = null;
this.activeProduct = null;
this.selectedPatch = '';
this.selectedExtraPatch = '';
this.selectedMedias = false;
this.selectedVariantId = '';
this.selectedVariantTitle = '';
      this.clearModalError();

      Object.values(this.fieldErrors).forEach((node) => {
        if (!node) return;
        node.hidden = true;
        node.textContent = '';
      });

      Object.entries(this.fieldWraps).forEach(([key, node]) => {
        if (!node) return;
        node.hidden = true;

        if (key === 'variant') return;

        const normalized = key === 'extraPatch' ? 'extraPatch' : key;
        if (this.toggles[normalized]) {
          this.toggles[normalized].checked = false;
          this.toggles[normalized].disabled = false;
        }
        if (this.panels[normalized]) {
          this.panels[normalized].hidden = true;
        }
      });

      if (this.variantGrid) this.variantGrid.innerHTML = '';
      if (this.playerPresetSelect) this.playerPresetSelect.innerHTML = '<option value="">' + this.escapeHtml(this.t('selectPlayer', 'Selecciona un jugador')) + '</option>';

      if (this.inputs.name) {
        this.inputs.name.value = '';
        this.inputs.name.readOnly = false;
      }

      if (this.inputs.number) {
        this.inputs.number.value = '';
        this.inputs.number.readOnly = false;
      }

      if (this.patchContainers.patch) this.patchContainers.patch.innerHTML = '';
      if (this.patchContainers.extraPatch) this.patchContainers.extraPatch.innerHTML = '';
    }

    openModal(product, existingLine = null) {
      this.resetModal();
      this.activeProduct = product;
      this.editingUid = existingLine ? existingLine.uid : null;

      this.modalTitle.textContent = product.displayTitle || this.t('personalizeProduct', 'Personalizar producto');
      this.modalSubtitle.textContent = this.t('configureBeforeAdding', 'Configura este producto antes de anadirlo al pack.');

      if (product.personalizationNotice) {
        this.modalNotice.hidden = false;
        this.modalNotice.textContent = product.personalizationNotice;
      } else {
        this.modalNotice.hidden = true;
        this.modalNotice.textContent = '';
      }

      this.setupVariantField(product, existingLine);
      this.setupPlayerPresetField(product);
      this.setupField('name', product.nameMode, product.nameDefault, existingLine?.properties?.Nombre || '');
      this.setupField('number', product.numberMode, product.numberDefault, existingLine?.properties?.['Número'] || '');
      this.setupPatchField('patch', product.patchMode, product.availablePatches || [], product.fixedPatch, existingLine?.properties?.Parche || '');
      this.setupPatchField('extraPatch', product.extraPatchMode, product.availableExtraPatches || [], product.fixedExtraPatch, existingLine?.properties?.['Parche extra'] || '');
      this.setupMediasField(product, existingLine?.properties?.Medias || '');

      this.modal.classList.remove('is-hidden');
      document.body.classList.add('pack-modal-open');
      this.modal.scrollTop = 0;

      const dialog = this.modal.querySelector('.pack-modal__dialog');
      if (dialog) dialog.scrollTop = 0;
    }

    setupVariantField(product, existingLine) {
      const wrap = this.fieldWraps.variant;
      const grid = this.variantGrid;
      if (!wrap || !grid) return;

      const variants = Array.isArray(product.variants) ? product.variants : [];
      const currentVariantId = String(existingLine?.variantId || product.variantId || '');
      const currentVariantTitle = existingLine?.variantTitle || product.variantTitle || '';

      if (!variants.length) {
        wrap.hidden = true;
        this.selectedVariantId = String(product.variantId || '');
        this.selectedVariantTitle = product.variantTitle || '';
        return;
      }

      wrap.hidden = false;
      grid.innerHTML = '';

      variants.forEach((variant) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'pack-modal__variant-button';
        button.textContent = variant.title === 'Default Title' ? this.t('uniqueVariant', 'Unica') : variant.title;
        button.disabled = !variant.available;
        button.dataset.variantId = String(variant.id);
        button.dataset.variantTitle = button.textContent;

        if (String(variant.id) === currentVariantId) {
          button.classList.add('is-selected');
          this.selectedVariantId = String(variant.id);
          this.selectedVariantTitle = button.textContent;
        }

        button.addEventListener('click', () => {
          if (button.disabled) return;

          grid.querySelectorAll('.pack-modal__variant-button').forEach((node) => {
            node.classList.remove('is-selected');
          });

          button.classList.add('is-selected');
          this.selectedVariantId = button.dataset.variantId || '';
          this.selectedVariantTitle = button.dataset.variantTitle || '';
          this.clearFieldError('variant');
          this.clearModalError();
        });

        grid.appendChild(button);
      });

      if (!this.selectedVariantId) {
        const firstAvailable = grid.querySelector('.pack-modal__variant-button:not([disabled])');
        if (firstAvailable) {
          firstAvailable.classList.add('is-selected');
          this.selectedVariantId = firstAvailable.dataset.variantId || '';
          this.selectedVariantTitle = firstAvailable.dataset.variantTitle || '';
        } else {
          this.selectedVariantId = '';
          this.selectedVariantTitle = currentVariantTitle;
        }
      }
    }

    setupPlayerPresetField(product) {
      const wrap = this.fieldWraps.playerPreset;
      const select = this.playerPresetSelect;
      const presets = Array.isArray(product?.playerPresets) ? product.playerPresets : [];
      const canUsePresets = product?.nameMode === 'editable' && product?.numberMode === 'editable' && presets.length > 0;

      if (!wrap || !select) return;

      if (!canUsePresets) {
        wrap.hidden = true;
        select.innerHTML = '<option value="">' + this.escapeHtml(this.t('selectPlayer', 'Selecciona un jugador')) + '</option>';
        return;
      }

      wrap.hidden = false;
      select.innerHTML = '<option value="">' + this.escapeHtml(this.t('selectPlayer', 'Selecciona un jugador')) + '</option>';

      presets.forEach((preset) => {
        const name = preset?.name || '';
        const number = preset?.number || '';
        const label = preset?.label || (name && number ? `${name} — ${number}` : name || number);

        if (!name || !number || !label) return;

        const option = document.createElement('option');
        option.value = `${name}|${number}`;
        option.textContent = label;
        option.dataset.playerName = name;
        option.dataset.playerNumber = number;
        select.appendChild(option);
      });
    }

    applyPlayerPreset() {
      const select = this.playerPresetSelect;
      if (!select) return;

      const option = select.options[select.selectedIndex];
      if (!option) return;

      const name = option.dataset.playerName || '';
      const number = option.dataset.playerNumber || '';

      if (!name && !number) return;

      if (name && this.toggles.name && this.panels.name && this.inputs.name && !this.toggles.name.disabled) {
        this.toggles.name.checked = true;
        this.panels.name.hidden = false;
        this.inputs.name.value = this.normalizeNameValue(name);
        this.clearFieldError('name');
      }

      if (number && this.toggles.number && this.panels.number && this.inputs.number && !this.toggles.number.disabled) {
        this.toggles.number.checked = true;
        this.panels.number.hidden = false;
        this.inputs.number.value = this.normalizeNumberValue(number);
        this.clearFieldError('number');
      }

      this.clearModalError();
    }

    normalizeNameValue(value) {
      return String(value || '')
        .normalize('NFC')
        .toUpperCase()
        .normalize('NFC')
        .replace(/[^\p{L}\p{M}\s.'’\-·]/gu, '')
        .replace(/\s+/g, ' ')
        .replace(/^\s+/, '');
    }

    normalizeNumberValue(value) {
      const digits = String(value || '').replace(/[^0-9]/g, '');
      if (!digits) return '';

      const num = parseInt(digits, 10);
      if (num > 99) return '99';

      return digits;
    }

    setupField(field, mode, defaultValue, existingValue) {
      const wrap = this.fieldWraps[field];
      const toggle = this.toggles[field];
      const panel = this.panels[field];
      const input = this.inputs[field];

      if (!wrap || !toggle || !panel || !input) return;

      if (mode === 'hidden') {
        wrap.hidden = true;
        return;
      }

      wrap.hidden = false;

      if (mode === 'fixed') {
        toggle.checked = true;
        toggle.disabled = true;
        panel.hidden = false;
        input.value = existingValue || defaultValue || '';
        input.readOnly = true;
      } else {
        toggle.disabled = false;
        toggle.checked = !!existingValue;
        panel.hidden = !toggle.checked;
        input.readOnly = false;
        input.value = existingValue || '';
      }
    }

    setupPatchField(field, mode, options, fixedPatch, existingValue) {
      const wrap = this.fieldWraps[field];
      const toggle = this.toggles[field];
      const panel = this.panels[field];
      const container = this.patchContainers[field];

      if (!wrap || !toggle || !panel || !container) return;

      if (mode === 'hidden') {
        wrap.hidden = true;
        return;
      }

      wrap.hidden = false;

      if (mode === 'fixed' && fixedPatch) {
        toggle.checked = true;
        toggle.disabled = true;
        panel.hidden = false;
        this.renderPatchOptions(container, [fixedPatch], field, existingValue || fixedPatch.value, true);
        if (field === 'patch') this.selectedPatch = existingValue || fixedPatch.value || '';
        if (field === 'extraPatch') this.selectedExtraPatch = existingValue || fixedPatch.value || '';
        return;
      }

      toggle.disabled = false;
      toggle.checked = !!existingValue;
      panel.hidden = !toggle.checked;
      this.renderPatchOptions(container, options, field, existingValue, false);

      if (field === 'patch') this.selectedPatch = existingValue || '';
      if (field === 'extraPatch') this.selectedExtraPatch = existingValue || '';
    }

    setupMediasField(product, existingValue) {
      const wrap = this.fieldWraps.medias;
      const toggle = this.toggles.medias;
      const panel = this.panels.medias;

      console.log('setupMediasField ejecutada', {
        wrap: wrap,
        toggle: toggle,
        panel: panel,
        mediasEnabled: product && product.mediasEnabled,
        mediasPackVariantId: product && product.mediasPackVariantId
      });

      if (!wrap || !toggle || !panel) return;

      if (!(product && product.mediasEnabled) || !Number(product && product.mediasPackVariantId)) {
        wrap.hidden = true;
        this.selectedMedias = false;
        return;
      }

      wrap.hidden = false;
      toggle.disabled = false;
      toggle.checked = existingValue === 'Si' || existingValue === 'Sí';
      panel.hidden = !toggle.checked;
      this.selectedMedias = toggle.checked;
    }

    renderPatchOptions(container, options, field, selectedValue, locked) {
      container.innerHTML = '';

      options.forEach((option) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'pack-modal__patch' + (selectedValue === option.value ? ' is-selected' : '');
        button.setAttribute('data-pack-patch-option', field);
        button.setAttribute('data-value', option.value || '');

        let inner = '';
        if (option.image) {
          inner += `<img src="${option.image}" alt="${this.escapeHtml(option.name || '')}">`;
        }
        inner += `<div class="pack-modal__patch-title">${this.escapeHtml(option.name || option.value || '')}</div>`;
        button.innerHTML = inner;

        button.addEventListener('click', () => {
          if (locked) return;

          const isSelected = button.classList.contains('is-selected');
          container.querySelectorAll('.pack-modal__patch').forEach((node) => node.classList.remove('is-selected'));

          if (isSelected) {
            if (field === 'patch') this.selectedPatch = '';
            if (field === 'extraPatch') this.selectedExtraPatch = '';
          } else {
            button.classList.add('is-selected');
            if (field === 'patch') this.selectedPatch = option.value || '';
            if (field === 'extraPatch') this.selectedExtraPatch = option.value || '';
          }

          this.clearFieldError(field);
          this.clearModalError();
        });

        container.appendChild(button);
      });
    }

    saveLine() {
      if (!this.activeProduct) return;

      const properties = {};
      let hasError = false;

      if (!this.selectedVariantId) {
        this.showFieldError('variant', this.t('variantRequired', 'Debes elegir una talla.'));
        hasError = true;
      }

      if (this.inputs.name) this.inputs.name.value = this.normalizeNameValue(this.inputs.name.value).trim();
      if (this.inputs.number) this.inputs.number.value = this.normalizeNumberValue(this.inputs.number.value);

      if (!this.validateField('name', this.activeProduct.nameMode, this.inputs.name?.value || '', this.t('nameRequired', 'Debes indicar el nombre.'))) {
        hasError = true;
      } else if (this.toggles.name?.checked) {
        properties['Nombre'] = this.inputs.name.value.trim();
      }

      if (!this.validateField('number', this.activeProduct.numberMode, this.inputs.number?.value || '', this.t('numberRequired', 'Debes indicar el numero.'))) {
        hasError = true;
      } else if (this.toggles.number?.checked) {
        properties['Número'] = this.inputs.number.value.trim();
      }

      if (!this.validatePatchField('patch', this.activeProduct.patchMode, this.selectedPatch || '', this.t('patchRequired', 'Debes elegir un parche.'))) {
        hasError = true;
      } else if (this.toggles.patch?.checked && this.selectedPatch) {
        properties['Parche'] = this.selectedPatch;
      }

      if (!this.validatePatchField('extraPatch', this.activeProduct.extraPatchMode, this.selectedExtraPatch || '', this.t('extraPatchRequired', 'Debes elegir el parche extra.'))) {
        hasError = true;
      } else if (this.toggles.extraPatch?.checked && this.selectedExtraPatch) {
        properties['Parche extra'] = this.selectedExtraPatch;
      }

      if (this.selectedMedias) {
  properties['Medias'] = 'Sí';
}

      if (hasError) {
        this.showModalError(this.t('modalReviewError', 'Revisa los campos marcados antes de guardar este producto.'));
        return;
      }

      const line = {
        uid: this.editingUid || this.makeUid(),
        product: this.activeProduct,
        variantId: this.selectedVariantId,
        variantTitle: this.selectedVariantTitle,
        properties
      };

      if (this.editingUid) {
        this.lines = this.lines.map((item) => item.uid === this.editingUid ? line : item);
      } else {
        this.lines.push(line);
      }

      this.closeModal();
      this.renderLines();
    }

    validateField(field, mode, value, message) {
      this.clearFieldError(field);

      if (mode === 'hidden') return true;
      if (!this.toggles[field]?.checked) return true;

      if (!value.trim()) {
        this.showFieldError(field, message);
        return false;
      }

      return true;
    }

    validatePatchField(field, mode, value, message) {
      this.clearFieldError(field);

      if (mode === 'hidden') return true;
      if (!this.toggles[field]?.checked) return true;

      if (!value.trim()) {
        this.showFieldError(field, message);
        return false;
      }

      return true;
    }

    renderLines() {
      if (!this.linesContainer) return;

      if (!this.lines.length) {
        this.linesContainer.innerHTML = `
          <div class="pack-builder__empty">
            <p class="pack-builder__summary-text">${this.escapeHtml(this.emptyText)}</p>
            <p class="pack-builder__summary-text">${this.escapeHtml(this.emptySubtext)}</p>
          </div>
        `;
      } else {
        this.linesContainer.innerHTML = this.lines.map((line) => {
          const variantRow = line.variantTitle && line.variantTitle !== 'Default Title' && line.variantTitle !== this.t('uniqueVariant', 'Unica')
            ? `<div><strong>${this.escapeHtml(this.t('size', 'Talla'))}:</strong> ${this.escapeHtml(line.variantTitle)}</div>`
            : '';

          const props = [
            variantRow,
            ...Object.entries(line.properties || {}).map(
              ([key, value]) => `<div><strong>${this.escapeHtml(key)}:</strong> ${this.escapeHtml(value)}</div>`
            )
          ].join('');

          return `
            <div class="pack-builder__selected-item">
              <div class="pack-builder__selected-image">
                ${line.product.displayImage ? `<img src="${line.product.displayImage}" alt="${this.escapeHtml(line.product.displayTitle)}">` : ''}
              </div>
              <div>
                <p class="pack-builder__selected-title">${this.escapeHtml(line.product.displayTitle)}</p>
                <div class="pack-builder__selected-meta">
                  ${props || '<div>' + this.escapeHtml(this.t('noPersonalization', 'Sin personalizacion')) + '</div>'}
                </div>
                <div class="pack-builder__selected-actions">
                  <button type="button" class="pack-builder__text-button" data-pack-edit="${line.uid}">${this.escapeHtml(this.t('edit', 'Editar'))}</button>
                  <button type="button" class="pack-builder__text-button pack-builder__text-button--remove" data-pack-remove="${line.uid}">${this.escapeHtml(this.t('remove', 'Eliminar'))}</button>
                </div>
              </div>
            </div>
          `;
        }).join('');
      }

      const count = this.lines.length;
      if (count < this.minRequired) {
        this.progressText.textContent = this.format(count === 1 ? 'progressIncompleteSingular' : 'progressIncompletePlural', 'Has anadido {{ count }} productos. Anade al menos {{ min }} para activar el pack.', { count: count, min: this.minRequired });
        this.submitButton.disabled = true;
      } else {
        this.progressText.textContent = this.format(count === 1 ? 'progressReadySingular' : 'progressReadyPlural', 'Has anadido {{ count }} productos. El pack ya esta listo para anadirse al carrito.', { count: count });
        this.submitButton.disabled = false;
      }
    }

    async submitPack() {
      if (this.isSubmitting) return;

      if (this.lines.length < this.minRequired) {
        this.submitButton.disabled = true;
        return;
      }

      this.isSubmitting = true;
      const originalText = this.submitButton.textContent;
      this.submitButton.disabled = true;
      this.submitButton.textContent = this.t('adding', 'Anadiendo...');

      const packGroup = `pack_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;

      const items = [];

this.lines.forEach((line) => {
  const mediasGroup = `medias_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;

  const properties = {
    ...line.properties,
    _pack_group: packGroup,
    _pack_title: this.packTitle,
    _pack_min_required: String(this.minRequired),
    _pack_source: this.packSource,
    _pack_item_uid: line.uid,
    _pack_original_unit_price: String(line.product.originalProductPrice || 0)
  };

  if (line.properties?.Medias === 'Sí') {
    properties._medias_group = mediasGroup;
  }

  items.push({
    id: Number(line.variantId),
    quantity: 1,
    properties
  });

  if (line.properties?.Medias === 'Sí' && line.product.mediasPackVariantId) {
    items.push({
      id: Number(line.product.mediasPackVariantId),
      quantity: 1,
      properties: {
        _is_medias_addon: 'true',
        _medias_group: mediasGroup,
        _pack_group: packGroup,
        _pack_title: this.packTitle,
        _pack_min_required: String(this.minRequired),
        _pack_source: this.packSource,
        _pack_item_uid: `${line.uid}_medias`,
        _pack_original_unit_price: '600'
      }
    });
  }
});

      try {
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({ items })
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.description || this.t('addPackError', 'No se pudo anadir el pack al carrito.'));
  }

  this.lines = [];
  this.editingUid = null;
  this.activeProduct = null;
  this.resetModal();
  this.renderLines();

  const cartDrawer = document.querySelector('cart-drawer');

  if (cartDrawer && theme.settings.afterAtc === 'drawer') {
    await cartDrawer.refresh(true);
    cartDrawer.open();
  } else if (window.location.pathname === theme.routes.cart) {
    const cartItems = document.querySelector('cart-items');
    if (cartItems) {
      if (cartItems.dataset.empty === 'true') {
        window.location.reload();
      } else {
        cartItems.refresh();
      }
    }
  } else {
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
  }

  this.submitButton.disabled = false;
  this.submitButton.textContent = originalText;
  this.isSubmitting = false;

} catch (error) {
  this.submitButton.disabled = false;
  this.submitButton.textContent = originalText;
  this.isSubmitting = false;
  alert(error.message || this.t('addPackError', 'No se pudo anadir el pack al carrito.'));
  return;
}

      this.isSubmitting = false;
    }

    closeModal() {
      this.modal.classList.add('is-hidden');
      document.body.classList.remove('pack-modal-open');
      this.resetModal();
    }

    showModalError(message) {
      this.modalError.hidden = false;
      this.modalError.textContent = message;
    }

    clearModalError() {
      this.modalError.hidden = true;
      this.modalError.textContent = '';
    }

    showFieldError(field, message) {
      const node = this.fieldErrors[field];
      if (!node) return;
      node.hidden = false;
      node.textContent = message;
    }

    clearFieldError(field) {
      const node = this.fieldErrors[field];
      if (!node) return;
      node.hidden = true;
      node.textContent = '';
    }

    makeUid() {
      return `line_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
    }

    escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }
  }

  customElements.define('pack-builder', PackBuilder);
}